export default "__VITE_ASSET__be6a8ea0__"